import type { Parcours } from '../types/database';

export const parcoursData: Parcours[] = [
  {
    id: 'parcours-1',
    nom: 'Trouble de la perception des couleurs',
    details: 'Découvrez les difficultés rencontrées par les personnes ayant des difficultés à percevoir et identifier les couleurs.',
    objectif: 'identifier des éléments colorés',
    datePublication: new Date('2024-01-15'),
    typeParcoursIds: ['troubles-visuels'],
    solutionId: 'solution-parcours-1',
    missionIds: ['mission-1-1', 'mission-1-2'],
    slug: 'trouble-perception-couleurs',
    fiche:{
      paragraphe:[
        "Pour rendre l’information accessible à ceux qui ne voient pas les couleurs ou les voient différemment, il ne faut <strong>pas donner l’information que par la couleur.</strong>",
        "On s’assure donc de <strong>faire passer l’information par un élément complémentaire clair et précis en combinaison de la couleur</strong> mais on fait aussi en sorte de <strong>ne pas rendre dépendant le parcours utilisateur à cette couleur</strong> uniquement."
      ],
      citation:'',
      image:'/img/solutions/parcours-1.png'
    }
  },

  {
    id: 'parcours-2',
    nom: 'Voir avec une maladie oculaire',
    details: 'Expérimente les différents troubles de la vue et comprend l’impact de pathologies neurologiques ou ophtalmologiques.',
    objectif: 'trouve une information spécifique avec une vue altérée.',
    datePublication: new Date('2024-02-01'),
    typeParcoursIds: ['troubles-visuels'],
    solutionId: 'solution-parcours-2',
    missionIds: ['mission-2-1','mission-2-2'],
    slug: 'maladie-oculaire',
    fiche:{
      paragraphe:[
        "Certaines personnes, par exemple avec une cataracte, rencontrent des <strong>difficultés à distinguer les détails fins et à lire lorsque le contraste entre texte et arrière-plan est trop faible.</strong>",
        "Pour rendre l’information accessible, il est essentiel de garantir une bonne lisibilité grâce à des <strong>contrastes suffisants</strong> et à une <strong>mise en page claire</strong>, afin que le contenu reste perceptible même en cas de vision réduite."
      ],
      citation:'Le contraste donne du relief à la réalité.',
      image:''
    }
  },
  {
    id: 'parcours-3',
    nom: 'Mouvements limités',
    details: 'Expérimente les défis d\'un handicap affectant la précision des mouvements des membres supérieurs.',
    objectif: 'réaliser une tâche nécessitant des clics précis.',
    datePublication: new Date('2024-02-01'),
    typeParcoursIds: ['troubles-moteurs'],
    solutionId: 'solution-parcours-3',
    missionIds: ['mission-3-1',],
    slug: 'mouvements-limites',
    fiche:{
      paragraphe:[
        "Certaines personnes, par exemple avec un Parkinson, rencontrent des <strong>difficultés pour cliquer sur des petites cibles</strong> à cause des mouvements non-maîtrisés.",
        "Pour rendre la navigation plus agréable et moins fatigante, il est recommandé de <strong>ne pas designer les éléments cliquables trop petits.</strong>"
      ],
      citation:'je sais pas ',
      image:''
    }
  },
  {
    id: 'parcours-4',
    nom: 'Troubles de l’attention ou de la mémoire',
    details: 'Expérimente les troubles cognitifs affectant la mémoire ou l’attention et leur impact dans les démarches en ligne.',
    objectif: 'retenir une suite de chiffres',
    datePublication: new Date('2024-02-01'),
    typeParcoursIds: ['troubles-cognitifs'],
    solutionId: 'solution-parcours-4',
    missionIds: ['mission-4-1'],
    slug: 'troubles-attention-memoire',
    fiche:{
      paragraphe:[
        "Certaines personnes avec un trouble de l’Attention, un trouble du spectre de l’Autisme ou une perte de mémoire, peuvent avoir des <strong>difficultés pour retenir les choses ou rester concentrées lors d’une tâche.</strong>",
        "Pour les aider, il est recommandé de <strong>limiter les sources de distractions et d’être le plus précis possible dans les consignes et réponses attendues</strong>"
      ],
      citation:'J’ai oublié d’écrire une phrase inspirante ici',
      image:''
    }
  },
  {
    id: 'parcours-5',
    nom: 'Lire et compter avec les troubles DYS',
    details: 'Découvre les difficultés que peuvent rencontrer les personnes ayant des troubles DYS pour écrire et comprendre du contenu.',
    objectif: 'comprendre un texte avec une dyslexie.',
    datePublication: new Date('2025-08-01'),
    typeParcoursIds: ['troubles-cognitifs'],
    solutionId: 'solution-parcours-5',
    missionIds: ['mission-5-1'],
    slug: 'lire-compter-troubles-dys',
    fiche:{
      paragraphe:[
        "Les difficultés rencontrées par les personnes ayant des troubles DYS sont nombreuses.",
        "Sur internet, elles peuvent notamment être gênée par <strong>le manque de contraste, des polices d’écriture difficiles à lire ou simplement à cause de la mise en page.</strong>"
      ],
      citation:'On connaît les mots mais ils refusent de se faire lire correctement.',
      image:''
    }
  },
  {
    id: 'parcours-6',
    nom: 'Comprendre sans entendre',
    details: 'Découvrez les difficultés rencontrées par les personnes ayant des troubles auditifs face à un contenu vidéo.',
    objectif: 'regarder une vidéo et la résumer',
    datePublication: new Date('2028-02-01'),
    typeParcoursIds: ['troubles-auditifs'],
    solutionId: 'solution-parcours-6',
    missionIds: [],
    slug: 'comprendre-sans-entendre',
    fiche:{
      paragraphe:[],
      citation:'',
      image:''
    }
  }
];